import {TFunction} from 'i18next';
import {CarePlanConfigurationFeature} from '../../../../../../backend/enums/care-plan-configuration-feature';
import {ExportCarePlanData} from '../../base/export-care-plan-types';
import {CommonBadlPdfDataProcessor} from '../export-care-plan-common-badl-pdf-data';

export class EliminationPdfDataProcessor extends CommonBadlPdfDataProcessor {
  // Inherits the same headers and row structure as Common processor.

  constructor(baseData: ExportCarePlanData, t: TFunction) {
    super(baseData, t);

    this.handleTaskDetailsCellValue = (entry) => {
      const toiletEntry = entry.getEntryByFeature(
        CarePlanConfigurationFeature.EliminationGoingToiletPlace
      );
      const consumablesEntry = entry.getEntryByFeature(
        CarePlanConfigurationFeature.EliminationGoingToiletConsumables
      );

      const toiletName = `<b>${toiletEntry?.name ?? 'n/a'}:</b>`;
      const toiletValue = this.getEntryValue(toiletEntry);
      const consumablesName = `<b>${consumablesEntry?.name ?? 'n/a'}:</b>`;
      const consumablesValue = this.getEntryValue(consumablesEntry);

      if (consumablesValue) {
        return `${toiletName}\n${toiletValue}\n<br>${consumablesName}\n${consumablesValue}`;
      }

      return `${toiletName}\n${toiletValue}`;
    };
  }
}
